import produce from 'immer';

import * as fromActions from './sales-appointment.actions';
import * as fromAdapter from './sales-appointment.adapter';
import { Transport } from '../../shared/models/transport';
import { SeriesData, VehicleColor } from './../../shared/models/series-data';
import { IAddress, IAsyncData, ICustomer, IVehicle, IAvailabilityOptions, IAvailability, AppointmentType } from '@signal/asp-data-commons';
import { getDateTime, fromAvailabilityOptions } from '../app.adapter';
import { IChecklistRequest, ISalesAppointment, IVehicleDetails } from '@signal/asp-data-commons/lib/interfaces/appointment';
import _ from 'lodash';
import { CustomerType } from '../../shared/enums/customer-types.enum';
import { countryCd } from '../../shared/services/util.service';

export function salesAppointmentReducer(
    state: SalesAppointmentState = initialState,
    action: fromActions.SalesAppointmentType): SalesAppointmentState {

    switch (action.type) {
        case fromActions.SalesAppointmentActionTypes.UPDATE_SALES_FORM_DATA: {
            const payload = action instanceof fromActions.UpdateSalesFormData ? action.payload : undefined;
                let appointment: ISalesAppointmentForm;
                if(payload.appointmentType === AppointmentType.DELIVERY) {
                    appointment = {
                        ...payload.value,
                        appointmentStatus: state.appointment.appointmentStatus,
                    };
                }
                else {
                     appointment = {...payload.value};
                    /*
                    *as vehicle info is not coming from learning form, it is coming from vehicle form
                    *also there is no address info it doesn't have any remote appointment, so manually adding the address here. It comes by choosing transportation.
                    */
                     if(payload.appointmentType === AppointmentType.LEARNING) {
                         appointment = {...appointment,vehicle:state.appointment.vehicle, address: state.appointment.address};
                     }
                }
            if(!(_.isEqual(state.appointment , appointment))) {
                return produce(state, draftState => {
                draftState.appointment = produce(appointment, draftValue => {
                    if (draftValue.availability && state.appointment.availability) {
                        draftValue.availability.advisorId = fromAdapter.updateAdvisorOnLanguageChange(state, draftValue.availability);
                        draftValue.availability.timeSlotId =
                            fromAdapter.updateTimeSlotOnDateChange(state, draftValue.availability);
                    }
                    // if(draftValue.transportationTypeCode === "DEALER") {
                    //     draftValue.remoteZipCode = "";
                    // }
                    if (draftValue.address && draftValue.transportationTypeCode === "REMOTE") {
                        draftValue.address.zip = draftValue.remoteZipCode;
                      
                    }

                });
            });
        }
        }

        case fromActions.SalesAppointmentActionTypes.UPDATE_SALES_AVAILABILITY_DATA : {
            return produce(state , draftState =>{
                const payload = action instanceof fromActions.UpdateSalesAvailabilityData ? action.payload : undefined;
                if (payload) {
                    draftState.appointment.availability.advisorId = payload.value.advisorId ? payload.value.advisorId : state.appointment.availability.advisorId ?? "-1";
                    draftState.appointment.availability.fniAdvisorId = payload.value.fniAdvisorId ? payload.value.fniAdvisorId : state.appointment.availability.fniAdvisorId ?? "-1";
                    draftState.appointment.availability.languageId = payload.value.languageId ? payload.value.languageId : state.appointment.availability.languageId;
                    draftState.appointment.availability.appointmentStartDate = payload.value.appointmentStartDate ? payload.value.appointmentStartDate : state.appointment.availability.appointmentStartDate;
                    draftState.appointment.availability.timeSlotId = payload.value.timeSlotId;
                }
            })
        }

        case fromActions.SalesAppointmentActionTypes.UPDATE_PATCH_SALES_FORM: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdatePatchSalesForm ? action.payload : undefined;
                if(payload && payload?.path) {
                    if(payload.path == 'mergeAll'){
                        draftState.appointment = {...state.appointment,...payload.value}
                        return;
                    }
                    draftState.appointment[payload.path] = payload.value;
                }
            });
          }

        case fromActions.SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER: {
            return produce(state, draftState => {
                
            });
        }

        case fromActions.SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER_SUCCESS: {
            return produce(state, draftState => {
                
            });
        }

        case fromActions.SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER_FAILURE: {
            return produce(state, draftState => {
                
            });
        }


        case fromActions.SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.CreateSalesAppointment ? action.payload : undefined;
                if (payload.appointmentType === AppointmentType.DELIVERY && payload.from === 'sendLink') {
                    draftState.appointment = {
                        ...draftState.appointment,
                        linkSentToCustomerOn: new Date().toISOString()
                    };
                }
            });
        }

        case fromActions.SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.CreateSalesAppointmentSuccess ? action.payload : undefined;
                draftState.editDetails = {
                    appointmentId: payload.appointmentModel.appointmentId,
                    isSubmitted: true,
                    appointmentData: payload.appointmentModel
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.CreateSalesAppointmentFail ? action.payload : undefined;
                draftState.editDetails = {
                    appointmentId: '',
                    isSubmitted: false
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.GET_EDIT_DATA: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.GetEditData ? action.payload : undefined;
                draftState.editDetails = {
                    appointmentId: payload.appointmentId,
                    isSubmitted: false
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.GET_EDIT_DATA_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.GetEditDataSuccess ? action.payload : undefined;
                draftState.appointment = fromAdapter.editDataPopulatedInState(payload.appointmentModel);
                draftState.editDetails.appointmentStatus = payload.appointmentModel.appointmentStatus;
                draftState.editDetails.dealerCode = payload.appointmentModel.dealerCode;
                draftState.editDetails.isEditMode = true;
            });
        }

        case fromActions.SalesAppointmentActionTypes.GET_EDIT_DATA_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.GetEditDataFail ? action.payload : undefined;
            });
        }

        case fromActions.SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT: {
            return produce(state, draftState => {
            });
        }

        case fromActions.SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.EditSalesAppointmentSuccess ? action.payload : undefined;
                draftState.editDetails = {
                    appointmentId: payload.appointmentModel.appointmentId,
                    isSubmitted: true,
                    appointmentData: payload.appointmentModel
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.EditSalesAppointmentFail ? action.payload : undefined;
                draftState.editDetails = {
                    appointmentId: '',
                    isSubmitted: false
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY: {
            return produce(state, draftState => {
                draftState.availability = {
                    data: state.availability.data,
                    loading: true,
                    loaded: false,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadAvailabilitySuccess ? action.payload : undefined;
                const availability = state.appointment.availability;
                if (!(availability?.timeSlotId && availability?.appointmentStartDate)) {
                    let dateTime;
                    if (availability && !availability.appointmentStartDate
                       && payload.loadPayload.selectDateAndSlot) {
                        dateTime = getDateTime(payload.availability);
                    } else {
                        dateTime = {
                            appointmentStartDate: availability?.appointmentStartDate,
                            timeSlotId: availability?.timeSlotId
                        };
                    }
                    draftState.appointment.transportationTypeCode = state.appointment.transportationTypeCode;
                    draftState.appointment.availability = {
                        ...availability,
                       // advisorId: payload.loadPayload.advisorId || availability.advisorId,
                        ...dateTime
                    };
                }
                draftState.availability = {
                    data: payload.availability,
                    loading: false,
                    loaded: true,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadAvailabilityFail ? action.payload : undefined;
                draftState.availability = {
                    data: {} as IAvailability,
                    loading: false,
                    loaded: false,
                    error: payload.error
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS: {
            return produce(state, draftState => {
                draftState.availabilityOptions = {
                    data: {} as IAvailabilityOptions,
                    loading: true,
                    loaded: false,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadAvailabilityOptionsSuccess ? action.payload : undefined;
                draftState.availabilityOptions = {
                    data: payload.availabilityOptions,
                    loading: false,
                    loaded: true,
                    error: ''
                };
                if (!state.editDetails?.appointmentId) {
                    const availability = fromAvailabilityOptions(payload.availabilityOptions,state.appointment.transportationTypeCode);
                    draftState.appointment.availability = availability.availability;
                    draftState.appointment.transportationTypeCode = availability.transport;
                }
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadAvailabilityOptionsFail ? action.payload : undefined;
                draftState.availabilityOptions = {
                    data: {} as IAvailabilityOptions,
                    loading: false,
                    loaded: false,
                    error: payload.error
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_SERIES_TRIM: {
            return produce(state, draftState => {
                draftState.seriesDetails = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_SERIES_TRIM_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadSeriesAndTrimSuccess ? action.payload : undefined;
                draftState.seriesDetails = {
                    data: payload.seriesDetails,
                    loading: false,
                    loaded: true,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_SERIES_TRIM_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadSeriesAndTrimFail ? action.payload : undefined;
                draftState.seriesDetails = {
                    data: [],
                    loading: false,
                    loaded: false,
                    error: payload.error
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS: {
            return produce(state, draftState => {
                draftState.exteriorColors = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadExteriorColorsSuccess ? action.payload : undefined;
                draftState.exteriorColors = {
                    data: payload.exteriorColors,
                    loading: false,
                    loaded: true,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadExteriorColorsFail ? action.payload : undefined;
                draftState.exteriorColors = {
                    data: [],
                    loading: false,
                    loaded: false,
                    error: payload.error
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.RESET_SALES_APPOINTMENT_STATE: {
            return initialState;
        }

        case fromActions.SalesAppointmentActionTypes.RESET_SALES_APPOINTMENT_FORM: {
            return produce(state, draftState => {
                draftState.appointment = initialAppointment;
            });
        }

        case fromActions.SalesAppointmentActionTypes.RESET_EXTERIOR_COLOR: {
            return produce(state, draftState => {
                draftState.exteriorColors = {
                    data: [],
                    loading: false,
                    loaded: false,
                    error: ''
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_CUSTOMER_DETAILS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadCustomerDetails ? action.payload : undefined;
                draftState.appointment.customer = {
                    firstName: payload.signedInUserDetails.firstName,
                    lastName: payload.signedInUserDetails.lastName,
                    emailAddress: payload.signedInUserDetails.emailAddress,
                    phoneNumber: payload.signedInUserDetails.phoneNumber,
                    customerType: payload.signedInUserDetails.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
                    businessName: payload.signedInUserDetails.businessName,
                    drvaFlag: payload.signedInUserDetails.drvaFlag
                };
            });
        }

        case fromActions.SalesAppointmentActionTypes.UPDATE_CUSTOMER_FORM_TRANSPORT: {
            return produce(state, draftState => {
              const payload = action instanceof fromActions.UpdateCustomerFormTransport ? action.payload : undefined;
              draftState.appointment.transportationTypeCode = payload.transportData;
              draftState.appointment.remoteZipCode = '';
            });
          }
        case fromActions.SalesAppointmentActionTypes.LOAD_TESTDRIVE_VIN_VEHICLE_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTestDriveVinVehiclecSuccess ? action.payload : undefined;
                const marketingTitle = payload?.data[0].marketingTitle;
                const vehicle:IVehicle = {
                    year: payload?.data[0].year,
                    model: payload?.data[0].model,
                    trim: payload?.data[0].trim,
                    exteriorColor: payload?.data[0].exteriorColor,
                    vin:payload?.data[0].vin,
                    imageUrl:payload?.data[0].imageUrl
                };
                const vehicleDetails:IVehicleDetails = {marketingTitle,...vehicle}
                draftState.allSeriesDetails = {
                    data: vehicleDetails,
                    loading: false,
                    loaded: false,
                    error: ''
                }
                // vehicle.model=vehicle.model?.replace(' ','')?.toLowerCase();
                /* this return is to handle exception where vin build data is not available */
                if(!vehicle.model){
                    return;
                }
                draftState.appointment.vehicle ={...vehicle };
            });
        }
        case fromActions.SalesAppointmentActionTypes.UPDATE_SENT_LINK_DATE:{
            return produce(state, draftState => {
                draftState.appointment.linkSentToCustomerOn = new Date().toISOString();
            });
          }
        case fromActions.SalesAppointmentActionTypes.CREATE_CHECKLIST: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.CreateChecklist ? action.payload : undefined;

                draftState.appointment.checklistRequest = payload.data;
            });
        }

        case fromActions.SalesAppointmentActionTypes.UPDATE_CURRENT_STEP: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateCurrentStep ? action.payload : undefined;
                draftState.currentStep = payload?.step;
            });
        }

        case fromActions.SalesAppointmentActionTypes.LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadSalesAppointmentFromSignalDeepLinkSuccess ? action.payload : undefined;
                const vehicleForm = state.appointment.vehicle;
                const vehicleDetails = {
                    make: (payload.data.vehicle.make) ? payload.data.vehicle.make : "",
                    otherMake: (payload.data.vehicle.otherMake) ? payload.data.vehicle.otherMake : "",
                    model: (payload.data.vehicle.model) ? payload.data.vehicle.model : "",
                    year: (payload.data.vehicle.year) ? payload.data.vehicle.year : "",
                    vin: payload.data.vehicle.vin
                }
                draftState.appointment.vehicle = {
                    ...vehicleForm,
                    ...vehicleDetails
                }
                const customer = payload.data.customer;
                const customerForm = state.appointment.customer;
                const customerDetails = {
                    firstName: (customer?.firstName) ? customer.firstName : "",
                    lastName: (customer?.lastName) ? customer.lastName : "",
                    emailAddress: (customer?.emailAddress) ? customer.emailAddress : ""
                }
                if (customer?.phoneNumber) {
                    customerDetails['phoneNumber'] = (countryCd === "USA") ? "+1" + customer.phoneNumber : "+52" + customer.phoneNumber
                }
                draftState.appointment.customer = {
                    ...customerForm,
                    ...customerDetails
                };
            });
        }
      
        default:
            return state;
    }

}

const initialVehicle: IVehicle = {
    year: null,
    model: null,
    trim: null,
    exteriorColor: null,
    vin:null,
    imageUrl: null,
    make: "",
    source:null
};

const initialOtherVehicles: IVehicle[] = [{
    year: null,
    model: '',
    trim: ''
}];

const initialTradeIn: ITradeInVehicle = {
    tradeInCheckbox: false,
    vehicle: [{
        year: null,
        make: null,
        model: null,
        vin: null,
        mileage: null,
        trim: null,
        isOwnVehicle: false
    }],
    title: '',
    trepresentativeInfo: '',
    dealerComments: '',
    tradeInComments: ''
};

const initialAddress: IAddress = {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
    country: ''
};

const initialCustomer: ICustomerForm = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    customerType: CustomerType.INDIVIDUAL,
    businessName: '',
    drvaFlag: false
};

const initialAvailability: IAvail = {
    timeSlotId: '',
    advisorId: '',
    languageId: '',
    appointmentStartDate: '',
};

const initialInquiryVehicle:  IInquiryVehicle = {
    vehicleType: {
        new: false,
        used: false,
        both: false
    },
    vehiclesOfInterest: {
        carsMinivan: false,
        trucks: false,
        crossoversSuv: false,
        electrified: false
    }
}

const initialAppointment: ISalesAppointmentForm = {
    transportationTypeCode: '',
    remoteZipCode: '',
    customer: initialCustomer,
    vehicle: initialVehicle,
    otherVehicles: initialOtherVehicles,
    tradeIn: initialTradeIn,
    availability: initialAvailability,
    address: initialAddress,
    appointmentStatus: '',
    checklistRequest: [],
    inquiryVehicle: initialInquiryVehicle
};


const initialVehicleDetails: IVehicleDetails = {
    ...initialVehicle,
    marketingTitle:null
}
const initialState = {
    editDetails: undefined,
    currentStep: 0,
    appointment: initialAppointment,
    transportOptions: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    availabilityOptions: {
        data: {} as IAvailabilityOptions,
        loading: false,
        loaded: false,
        error: ''
    },
    availability: {
        data: {} as IAvailability,
        loading: false,
        loaded: false,
        error: ''
    },
    seriesDetails: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    allSeriesDetails: {
        data: {
            ...initialVehicleDetails
        },
        loading: false,
        loaded: false,
        error: ''
    },
    exteriorColors: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    }
};

export interface SalesAppointmentState {
    editDetails: IEditDetails;
    appointment: ISalesAppointmentForm;
    transportOptions: IAsyncData<Transport[]>;
    availabilityOptions: IAsyncData<IAvailabilityOptions>;
    availability: IAsyncData<IAvailability>;
    seriesDetails: IAsyncData<SeriesDetailsForYear[]>;
    allSeriesDetails: IAsyncData<IVehicle>;
    exteriorColors: IAsyncData<VehicleColor[]>;
    currentStep: number;
}

export interface IEditDetails {
    isEditMode?: boolean;
    email?: string;
    appointmentId: string;
    dealerCode?: string;
    appointmentStatus?: string;
    isSubmitted?: boolean;
    appointmentData?: ISalesAppointment;
}

export interface SeriesDetailsForYear {
    year: string;
    seriesDetails: SeriesData[];
}

export interface ITradeInVehicle {
    tradeInCheckbox: boolean;
    vehicle: IVehicle[];
    title?: string;
    trepresentativeInfo?: string;
    dealerComments?: string;
    tradeInComments?: string;
    internalComments?: string;
    additionalComments?: string;
}

export interface IAvail {
    timeSlotId: string;
    advisorId: string;
    fniAdvisorId?: string;
    languageId: string;
    appointmentStartDate: string;
}

export type ICustomerForm = ICustomer ;

export interface IInquiryVehicle {
    vehicleType: {
        new: boolean,
        used: boolean,
        both: boolean
    },
    vehiclesOfInterest: {
        carsMinivan: boolean,
        trucks: boolean,
        crossoversSuv: boolean,
        electrified: boolean
    }
}

export interface ISalesAppointmentForm {
    vehicle?: IVehicleDetails;
    otherVehicles?: IVehicle[];
    tradeIn?: ITradeInVehicle;
    transportationTypeCode: string;
    remoteZipCode: string;
    availability: IAvail;
    customer: ICustomerForm;
    appointmentComments?: string;
    linkSentToCustomerOn?:string;
    address?: IAddress;
    appointmentStatus?: string;
    checklistRequest?: IChecklistRequest[];
    inquiryVehicle?: IInquiryVehicle;
}

export interface IFooterSummary {
    key: string;
    value: string | number;
    disclaimer?: string;
  }